import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WidgetBaseDetailComponent } from '../../../../shared/components/widget-base-detail/widget-base-detail.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { VendorPriceListAddressLink } from '../../../../generated/generated-types';
import { HotkeysService } from '../../../hotkeys/services/hotkeys.service';
import { VendorPriceListAddressLinkService } from '../../services/vendor-price-list-address-link.service';
import { VendorPriceListLinkDetailFallbackFields } from './fallback';

@Component({
  selector: 'app-vendor-price-list-link-detail-widget',
  templateUrl: './../../../../common/base-detail.component.html',
  // template: `<app-base-detail-dialog-wrapper [baseDetailComponent]="this" />{{ this.detailModel | json }}`
  changeDetection: ChangeDetectionStrategy.Default, // If you change to OnPush check if it still loading data on the forst load!!! It braks the loading of the data if you use OnPush!!!!
  standalone: true,
  providers: [HotkeysService],
  imports: [
    WidgetBaseDetailComponent
  ]
})
export class VendorPriceListLinkDetailWidgetComponent extends BaseDetailComponent<VendorPriceListAddressLink> {

  protected override crudService = inject(VendorPriceListAddressLinkService);

  constructor() {
    super();

    this.fallbackFields = VendorPriceListLinkDetailFallbackFields();
  }
}